import React from "react";

import { Flex } from "../Flex";
import { IconStarRating } from "../Icon";
import { IconSVG } from "../Icon/icons/IconSVG";

export type StarRatingProps = {
  /** an int or float between 0 and 5 */
  rating: number;
  /** number in px */
  width?: number;
  children?: React.ReactNode;
  /** the fill colour of the stars */
  starColour?: string;
  /** the background colour outside the stars */
  backgroundColour?: string;
};

const BASE_WIDTH = 122;
const BASE_HEIGHT = 22;

export const StarRating: React.FC<StarRatingProps> = ({
  children,
  rating,
  starColour = "#ffb700",
  width = BASE_WIDTH,
  backgroundColour = "#FFF",
}) => {
  const barWidth = (rating / 5) * 100 + 5 * Math.floor(rating);
  const barHeight = Math.round(width / (BASE_WIDTH / BASE_HEIGHT));

  return (
    <Flex alignItems="center">
      {children}
      <IconSVG
        viewBox={`0 0 ${BASE_WIDTH} ${BASE_HEIGHT}`}
        preserveAspectRatio="xMinYMin slice"
        width={`${width}px`}
        height={`${barHeight}px`}
        role="img"
      >
        <title>{`${rating} Star Rating`}</title>
        <rect
          className="bg-rect"
          x="1"
          y="1"
          width={`${BASE_WIDTH}px`}
          height={`${BASE_HEIGHT}px`}
          fill="#ddd"
        />
        <rect
          className="rating-rect"
          x="1"
          y="1"
          width={`${barWidth}px`}
          height={`${BASE_HEIGHT}px`}
          fill={starColour}
        />
        <IconStarRating fill={backgroundColour} />
      </IconSVG>
    </Flex>
  );
};

StarRating.displayName = "StarRating";

export default StarRating;
